import Vue from 'vue'
import './plugins/gtm'
import './plugins/veevalidate'
import './plugins/portalvue'
import './plugins/scrollTo'
import './plugins/filters'
import './plugins/directives'
import './plugins/moment'
import vuetify from './plugins/vuetify'
import axiosPlugin from './plugins/axios'
import App from './App.vue'
import store from './store/store'
import router from './router'
import routerCustom from './router__custom'
import './styles/style.scss'
import Config from '@/modules/config/models/Config'

Vue.config.productionTip = false
Vue.use(axiosPlugin)

let options = {
  store,
  vuetify,
  render: h => h(App)
}

async function initConfig() {
  await Config.dispatch('get')
  store.state.isSDECC = Config.value('isSDECC') == 1 ? true : false
  store.state.SDECCcred = {
    customClassId: Config.value('classID'),
    teacherUser: Config.value('teacherUser'),
    teacherPass: Config.value('teacherPass')
  }
  if (store.state.isSDECC === true) {
    options.router = routerCustom
  } else {
    options.router = router
  }
  new Vue(options).$mount('#app')
}
initConfig()
